// Arqueo consolidado en Bs base: el teórico y el conteo físico se llevan a Bs con la tasa vigente.
const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const num = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
};

export const CUADRE_TOLERANCE_BS = 0.05;

export function computeCashClose(session = {}, counted = {}, rates = {}) {
    const usd = Number(rates.bs_per_usd) || 0;
    const cop = Number(rates.bs_per_cop) || 0;
    const aperturaTotalBs = r2(num(session.opening_bs) + num(session.opening_usd) * usd + num(session.opening_cop) * cop);
    const ventasBs = r2(session.total_sales_bs);
    const premiosNetosBs = r2(session.total_payouts_bs);
    const teoricoBs = r2(aperturaTotalBs + ventasBs - premiosNetosBs);
    const contadoBs = r2(num(counted.closing_bs) + num(counted.closing_usd) * usd + num(counted.closing_cop) * cop);
    const diferenciaBs = r2(contadoBs - teoricoBs);
    const status = Math.abs(diferenciaBs) < CUADRE_TOLERANCE_BS ? "cuadrado" : diferenciaBs > 0 ? "sobrante" : "faltante";
    return { aperturaTotalBs, ventasBs, premiosNetosBs, teoricoBs, contadoBs, diferenciaBs, status };
}
